/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    EventAttachmentCreateParams,
    EventAttachmentCreateParamsFromJSON,
    EventAttachmentCreateParamsFromJSONTyped,
    EventAttachmentCreateParamsToJSON,
} from './EventAttachmentCreateParams';
import {
    Field,
    FieldFromJSON,
    FieldFromJSONTyped,
    FieldToJSON,
} from './Field';
import {
    ProgramEventSeries,
    ProgramEventSeriesFromJSON,
    ProgramEventSeriesFromJSONTyped,
    ProgramEventSeriesToJSON,
} from './ProgramEventSeries';
import {
    ProgramEventVenueCreateParams,
    ProgramEventVenueCreateParamsFromJSON,
    ProgramEventVenueCreateParamsFromJSONTyped,
    ProgramEventVenueCreateParamsToJSON,
} from './ProgramEventVenueCreateParams';
import {
    RecurringOption,
    RecurringOptionFromJSON,
    RecurringOptionFromJSONTyped,
    RecurringOptionToJSON,
} from './RecurringOption';
import {
    RegistrationOptionDuplicateParams,
    RegistrationOptionDuplicateParamsFromJSON,
    RegistrationOptionDuplicateParamsFromJSONTyped,
    RegistrationOptionDuplicateParamsToJSON,
} from './RegistrationOptionDuplicateParams';

/**
 * 
 * @export
 * @interface ProgramEventDuplicateParams
 */
export interface ProgramEventDuplicateParams {
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    description?: string;
    /**
     * 
     * @type {Array<ProgramEventVenueCreateParams>}
     * @memberof ProgramEventDuplicateParams
     */
    venues?: Array<ProgramEventVenueCreateParams>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventDuplicateParams
     */
    online_event: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    online_event_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    terms?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    picture_file_id?: string;
    /**
     * 
     * @type {Array<Field>}
     * @memberof ProgramEventDuplicateParams
     */
    fields: Array<Field>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramEventDuplicateParams
     */
    tags: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventDuplicateParams
     */
    is_series?: boolean;
    /**
     * 
     * @type {Array<ProgramEventSeries>}
     * @memberof ProgramEventDuplicateParams
     */
    series_dates?: Array<ProgramEventSeries>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventDuplicateParams
     */
    show_remaining?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramEventDuplicateParams
     */
    restrict_to_package_ids?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventDuplicateParams
     */
    preregistration_enabled?: boolean;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof ProgramEventDuplicateParams
     */
    currency: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    appointment_type_id?: string;
    /**
     * 
     * @type {Array<EventAttachmentCreateParams>}
     * @memberof ProgramEventDuplicateParams
     */
    attachments?: Array<EventAttachmentCreateParams>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventDuplicateParams
     */
    has_external_registration: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    external_registration_url?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventDuplicateParams
     */
    feedback_enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    id: string;
    /**
     * An ISO 8601-compliant string representation of this event's start date component ('yyyy-MM-dd').
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    starts_at_date: string;
    /**
     * An ISO 8601-compliant string representation of this event's start time component ('yyyy-MM-dd').
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    starts_at_time: string;
    /**
     * An ISO 8601-compliant string representation of this event's end date component ('yyyy-MM-dd').
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    ends_at_date: string;
    /**
     * An ISO 8601-compliant string representation of this event's end time component ('yyyy-MM-dd').
     * @type {string}
     * @memberof ProgramEventDuplicateParams
     */
    ends_at_time: string;
    /**
     * day of the week, as number from 1-7 (Monday is 1, Sunday is 7)
     * @type {Array<string>}
     * @memberof ProgramEventDuplicateParams
     */
    occurs_on_day?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProgramEventDuplicateParams
     */
    occurs_on_month?: number;
    /**
     * 
     * @type {RecurringOption}
     * @memberof ProgramEventDuplicateParams
     */
    recurs?: RecurringOption;
    /**
     * 
     * @type {Array<RegistrationOptionDuplicateParams>}
     * @memberof ProgramEventDuplicateParams
     */
    options?: Array<RegistrationOptionDuplicateParams>;
}

export function ProgramEventDuplicateParamsFromJSON(json: any): ProgramEventDuplicateParams {
    return ProgramEventDuplicateParamsFromJSONTyped(json, false);
}

export function ProgramEventDuplicateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramEventDuplicateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'venues': !exists(json, 'venues') ? undefined : ((json['venues'] as Array<any>).map(ProgramEventVenueCreateParamsFromJSON)),
        'online_event': json['online_event'],
        'online_event_url': !exists(json, 'online_event_url') ? undefined : json['online_event_url'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'terms': !exists(json, 'terms') ? undefined : json['terms'],
        'picture_file_id': !exists(json, 'picture_file_id') ? undefined : json['picture_file_id'],
        'fields': ((json['fields'] as Array<any>).map(FieldFromJSON)),
        'tags': json['tags'],
        'is_series': !exists(json, 'is_series') ? undefined : json['is_series'],
        'series_dates': !exists(json, 'series_dates') ? undefined : ((json['series_dates'] as Array<any>).map(ProgramEventSeriesFromJSON)),
        'show_remaining': !exists(json, 'show_remaining') ? undefined : json['show_remaining'],
        'restrict_to_package_ids': !exists(json, 'restrict_to_package_ids') ? undefined : json['restrict_to_package_ids'],
        'preregistration_enabled': !exists(json, 'preregistration_enabled') ? undefined : json['preregistration_enabled'],
        'currency': CurrencyCodeFromJSON(json['currency']),
        'appointment_type_id': !exists(json, 'appointment_type_id') ? undefined : json['appointment_type_id'],
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(EventAttachmentCreateParamsFromJSON)),
        'has_external_registration': json['has_external_registration'],
        'external_registration_url': !exists(json, 'external_registration_url') ? undefined : json['external_registration_url'],
        'feedback_enabled': json['feedback_enabled'],
        'timezone': json['timezone'],
        'id': json['id'],
        'starts_at_date': json['starts_at_date'],
        'starts_at_time': json['starts_at_time'],
        'ends_at_date': json['ends_at_date'],
        'ends_at_time': json['ends_at_time'],
        'occurs_on_day': !exists(json, 'occurs_on_day') ? undefined : json['occurs_on_day'],
        'occurs_on_month': !exists(json, 'occurs_on_month') ? undefined : json['occurs_on_month'],
        'recurs': !exists(json, 'recurs') ? undefined : RecurringOptionFromJSON(json['recurs']),
        'options': !exists(json, 'options') ? undefined : ((json['options'] as Array<any>).map(RegistrationOptionDuplicateParamsFromJSON)),
    };
}

export function ProgramEventDuplicateParamsToJSON(value?: ProgramEventDuplicateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'summary': value.summary,
        'description': value.description,
        'venues': value.venues === undefined ? undefined : ((value.venues as Array<any>).map(ProgramEventVenueCreateParamsToJSON)),
        'online_event': value.online_event,
        'online_event_url': value.online_event_url,
        'url': value.url,
        'terms': value.terms,
        'picture_file_id': value.picture_file_id,
        'fields': ((value.fields as Array<any>).map(FieldToJSON)),
        'tags': value.tags,
        'is_series': value.is_series,
        'series_dates': value.series_dates === undefined ? undefined : ((value.series_dates as Array<any>).map(ProgramEventSeriesToJSON)),
        'show_remaining': value.show_remaining,
        'restrict_to_package_ids': value.restrict_to_package_ids,
        'preregistration_enabled': value.preregistration_enabled,
        'currency': CurrencyCodeToJSON(value.currency),
        'appointment_type_id': value.appointment_type_id,
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as Array<any>).map(EventAttachmentCreateParamsToJSON)),
        'has_external_registration': value.has_external_registration,
        'external_registration_url': value.external_registration_url,
        'feedback_enabled': value.feedback_enabled,
        'timezone': value.timezone,
        'id': value.id,
        'starts_at_date': value.starts_at_date,
        'starts_at_time': value.starts_at_time,
        'ends_at_date': value.ends_at_date,
        'ends_at_time': value.ends_at_time,
        'occurs_on_day': value.occurs_on_day,
        'occurs_on_month': value.occurs_on_month,
        'recurs': RecurringOptionToJSON(value.recurs),
        'options': value.options === undefined ? undefined : ((value.options as Array<any>).map(RegistrationOptionDuplicateParamsToJSON)),
    };
}

